<template>
  <div id="ClientTab" class="client-tab">
    <ul class="tabs-ul">
      <li
          v-for="(tab, index) in tabs"
          :key="index"
          class="tabs-li"
          :class="{'active-tab': activeTabCode === tab.code}"
          @click="tabClick(tab)"
      >
        <i class="gjw-iconfont" :class="tab.icon" />
        <span class="tab-name">{{tab.name}}</span>
      </li>
    </ul>
    <!-- 登录信息 -->
    <div v-if="showUserInfo" ref="headerCollapse" class="user-info">
      <div v-if="user.name">
        <div class="user-brief-info">
          <img class="avatar" :src="user.avatar">
          <span class="user-name" :title="user.name">{{ user.name }}</span>
          <i class="gjw-iconfont gjw-icon-drop-triangle ft-dark-grey"/>
        </div>
        <gjw-collapse>
          <ul v-show="showCollapse" ref="menu" class="user-menu gjw-shadow-small">
            <li class="user-info-menu-item">
              <img :src="user.avatar">
              <span class="user-name" :title="user.name">{{ user.name }}</span>
              <span class="user-mobile" :title="user.mobile">手机号：{{ user.mobile }}</span>
            </li>
            <li class="user-menu-item">
            <span @click="userInfo()">
              <i class="gjw-iconfont gjw-icon-shezhi"></i>
              个人信息
            </span>
            </li>
            <li class="user-menu-item" @click="logout()">
              <i class="gjw-iconfont gjw-icon-rongqi"></i>
              退出登录
            </li>
          </ul>
        </gjw-collapse>
      </div>
      <div v-else class="login-text" @click="toLogin">登录/注册</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GjwCollapse from '@/components/lib/GjwCollapse.vue'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import openUrlMixin from '@/mixins/openUrlMixin'
export default {
  name: 'ClientTab',
  components: {
    GjwCollapse
  },
  mixins: [checkLoginMixin, openUrlMixin],
  data() {
    return {
      showCollapse: false,
      allTab: [
        {
          icon: 'gjw-icon-goujian',
          name: '构件库',
          code: 'component', // 对应$route.meta.module
          routerName: 'ComponentList',
          appList: ['AppGarch', 'AppGstr', 'AppGmep', 'AppGroad', 'AppDeco', 'AppGbr', 'bimmake'],
        }, {
          icon: 'gjw-icon-chanpinku',
          name: '产品库',
          code: 'product', // 对应$route.meta.module
          routerName: 'StartSearch',
          appList: ['AppGmep'],
        }, {
          icon: 'gjw-icon-mokuai',
          name: '模块库',
          code: 'module', // 对应$route.meta.module
          routerName: 'ModuleList',
          appList: ['AppGarch', 'AppGstr'],
        }, {
          icon: 'gjw-icon-cailiao1',
          name: '标准材料库',
          code: 'material', // 对应$route.meta.module
          routerName: 'MaterialList',
          appList: ['AppGarch'],
        }, {
          icon: 'gjw-icon-cailiao1',
          name: '模板库',
          code: 'scheme', // 对应$route.meta.module
          routerName: 'SchemeList',
          appList: ['AppGbr'],
        }, {
          icon: 'gjw-icon-rongqi4',
          name: '专题场景库',
          code: 'scene', // 对应$route.meta.module
          routerName: 'SceneList',
          appList: ['AppGarch', 'AppGmep', 'AppGstr'],
          tracks: {
            event: 'visitSceneList',
            params: {
              g_c_source: 'shop_gjw',
            }
          },
        },
      ],
      activeTabCode: this.$route.meta.module
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      userToken: 'user/userToken',
      softwareCode: 'softwareCode',
      fromEntrance: 'fromEntrance', // 是否从特定入口进来
      isStandalone: 'isStandalone', // 是否是本地版
    }),
    // 软件对应的tab
    tabs() {
      if (['ENT_GAP_ENGINEERING_PRACTICE', 'ENT_GDC_PROJECT_COMPONENT'].includes(this.fromEntrance)) {
        // 从特定入口进来，则只展示页面对应的tab,否则显示默认软件tab
        const routeModule = this.$route.meta.module
        return this.allTab.filter((item) => {
          return item.code === routeModule
        })
      } else {
        const softwareCode = this.softwareCode
        return this.allTab.filter((item) => {
          return item.appList.includes(softwareCode)
        })
      }
    },
    showUserInfo() {
      return this.isStandalone && ['AppGarch', 'AppGmep', 'AppGstr'].includes(this.softwareCode)
    },
  },
  watch: {
    '$route.name': {
      handler() {
        this.activeTabCode = this.$route.meta.module
      },
      immediate: true
    }
  },
  created() {
    this.loadUserInfo()
  },
  mounted() {
    const collapse = this.$refs.headerCollapse
    if (collapse) {
      collapse.addEventListener('mouseenter', () => { this.showCollapse = true }, false)
      collapse.addEventListener('mouseleave', () => { this.showCollapse = false }, false)
      this.$once('hook:beforeDestroy', () => {
        collapse.removeEventListener('mouseenter', () => { this.showCollapse = true })
        collapse.removeEventListener('mouseleave', () => { this.showCollapse = false })
      })
    }
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      userLogout: 'user/logout',
      logoutPlugin: 'user/logoutPlugin',
    }),
    tabClick(tab) {
      // 校验是否登录
      if (!this.userToken) {
        this.toLogin()
      } else {
        if (tab.code !== this.activeTabCode) {
          this.activeTabCode = tab.code
          if (tab.tracks) {
            this.$tracks(tab.tracks)
          }
          this.$router.push({
            name: tab.routerName,
            query: this.$route.query,
            params: this.$route.params,
          })
        }
      }
    },
    toLogin() {
      this.showLoginDialog()
    },
    async logout() {
      // 通过端，退出登录
      // const dest = window.location.href
      await this.logoutPlugin({ token: this.userToken })
      // 隐藏用户信息悬浮窗
      this.showCollapse = false
      await this.showLoginDialog()
    },
    userInfo() {
      // 通过端，打开浏览器
      const url = `${process.env.VUE_APP_GJW_PORTAL_URL}/private#/user`
      this.openUrl(url, true)
    },
  }
}
</script>

<style lang="less" scoped>
.client-tab{
  height: 40px;
  line-height: 40px;
  background: #F7F9FA;
  border-top: 1px solid #D2D9E3;
  border-bottom: 1px solid #D2D9E3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.tabs-ul{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  .tabs-li{
    padding: 0 20px;
    height: 38px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-right: 1px solid #D2D9E3;
    &.active-tab{
      color: @theme-color;
      background: #fff;
    }
    .gjw-iconfont{
      font-size: 16px;
      margin-right: 4px;
    }
    .tab-name{
      font-size: 14px;
    }
  }
}
.user-brief-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  img {
    width: 24px;
    height: 24px;
    border-radius: 16px;
  }
  .user-name {
    display: inline-block;
    font-size: 14px;
    padding-left: 10px;
    max-width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #282832;
    cursor: default;
  }
}
.user-info {
  margin-right: 10px;
}
.user-menu {
  position: absolute;
  right: 10px;
  border-radius: 2px;
  z-index: 10000;
  background: white;
  color: #50525A;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),0px 6px 16px 0px rgba(0, 0, 0, 0.08),0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  .user-info-menu-item {
    border-bottom: 1px solid #D2D9E3;
    min-width: 246px;
    min-height: 70px;
    font-size: 14px;
    line-height: 70px;
    padding: 0 16px;
    box-sizing: border-box;
    img {
      position: absolute;
      left: 18px;
      top: 18px;
      width: 40px;
      height: 40px;
      border-radius: 99px;
      opacity: 1;
      /* 自动布局 */
      display: flex;
      flex-direction: row;
      padding: 0px;
    }
    .user-name {
      position: absolute;
      left: 73px;
      top: 18px;
      height: 20px;
      opacity: 1;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      text-align: left;
      align-items: center;
      letter-spacing: 0;
      width: 165px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      /* 正文 */
      color: #495F70;
    }
    .user-mobile {
      position: absolute;
      left: 73px;
      top: 38px;
      width: 126px;
      height: 20px;
      opacity: 0.65;
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      text-align: center;
      display: flex;
      align-items: center;
      letter-spacing: 0;
      /* 辅助文字 */
      color: rgba(73, 95, 112, 0.6);
    }
  }
  .user-menu-item {
    min-width: 152px;
    min-height: 40px;
    font-size: 14px;
    line-height: 40px;
    padding: 0 16px;
    box-sizing: border-box;
    text-align: left;
    cursor: pointer;
    &:hover {
      background: #F5F5FA;
      color: #2DAFCD;
      transition: all 0.3s;
    }
    &:active {
      color: #2DAFCD;
    }
    a {
      color: inherit;
      display: block;
    }
  }
}
</style>
